// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2yuCa","search":"Settings_search__1PVYw","filter":"Settings_filter__2tiGJ"};